<div class="form-input telephone-field"
[ngClass]="{'predefined-value': predefinedStyleEnabled}">
    <div class="desc-icon">
        <app-tooltip-icon *ngIf="fieldConfig.description!=undefined"
                          [description]="fieldConfig.description"></app-tooltip-icon>
    </div>

    <div class="telephone-field__placeholder">{{ (placeholder? placeholder: '')| translate }}</div>

    <mat-form-field class="telephone-field__short"
                    (click)="onClick($event)">
        <input matInput
               [(ngModel)]="prefix"
               id="{{fieldConfig.fieldKey + 'MaskInput'}}"
               (blur)="prefixChange()"
               [disabled]="true"
               autocomplete="disabled"
               tabindex="-1"
               [readonly]="fieldConfig.readonly"
               type="tel"
               [name]="fieldConfig.key"
               [mask]="'00'"
               prefix="+"
        >
        <mat-hint *ngIf="verificationHintVisible">&nbsp;</mat-hint>
    </mat-form-field>

    <mat-form-field class="telephone-field__long"
                    (click)="onClick($event)"
                    [ngClass]="{'telephone-field__long--with-icon': informationIconVisible}">
        <input matInput
               [(ngModel)]="number"
               id="{{fieldConfig.fieldKey + 'Input'}}"
               (blur)="numberChange()"
               [autocomplete]="autocompleteAllowed ? fieldConfig.autocomplete : undefined"
               [readonly]="fieldConfig.readonly"
               type="tel"
               [name]="fieldConfig.key"
               [mask]="'000 000 000'"
        >
        <mat-icon matSuffix *ngIf="fieldConfig.properties!==undefined && fieldConfig.properties['matSuffix']">
            {{fieldConfig.properties['matSuffix']}}
        </mat-icon>
        <mat-hint *ngIf="verificationHintVisible" class="predefined-value__color">{{'HINTS.verificationRequired' | translate}}</mat-hint>

        <app-information-icon class="information-icon phone-number-field" *ngIf="informationIconVisible"
                              [information]="fieldConfig.predefined.additionalInfo | additionalInfo"
                              [description]="fieldConfig.description | translate">
        </app-information-icon>
    </mat-form-field>


    <mat-error class="telephone-field__error" *ngIf="errorsMap.get(fieldConfig.fieldKey)">{{ (context + '.' +
        fieldConfig.fieldKey + '.' + errorsMap.get(fieldConfig.fieldKey))|translate}}
    </mat-error>

   <div class="desc-icon">
        <app-tooltip-icon *ngIf="tooltipIconVisible"
                          [description]="fieldConfig.description"></app-tooltip-icon>

    </div>

</div>
